"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadedFiles = exports.initialState = exports.STRUCTURE_CREATED = void 0;
var monocle = require("monocle-ts");
var Types = require("types");
exports.STRUCTURE_CREATED = 'STRUCTURE_CREATED';
var initialFileProgress = {
    percent: 0,
    loadedSize: 0,
    status: Types.STANDBY,
    message: ''
};
exports.initialState = {};
var itemLens = function (key) {
    return monocle.Lens.fromProp(key);
};
// REDUCERS
var methods = {};
methods['/FILEUPLOAD_FILE_UPDATE'] = function (state, action) {
    return action.payload.reduce(function (s, item) {
        return itemLens(item.uuid).modify(function (i) {
            if (i && (i.status === 'UPLOADED' || i.status === 'FAILED')) {
                return i;
            }
            return {
                percent: item.percent,
                loadedSize: item.loadedSize,
                status: 'UPLOADING',
                message: i ? i.message : ''
            };
        })(s);
    }, state);
};
methods['/FILEUPLOAD_FILE_REQUEST'] = function (state, action) {
    var uploadItems = action.payload.uploadItems;
    return uploadItems.reduce(function (state, item) {
        return itemLens(item.uuid).set(__assign({}, initialFileProgress))(state);
    }, state);
};
methods['/FILEUPLOAD_FILE_SUCCESS'] = function (state, action) {
    return action.payload.reduce(function (s, item) {
        return itemLens(item.uuid).modify(function (i) { return ({
            percent: i ? i.percent : 100,
            loadedSize: i ? i.loadedSize : 0,
            status: 'UPLOADED',
            message: i ? i.message : ''
        }); })(s);
    }, state);
};
methods['/FILEUPLOAD_FILE_FAILURE'] = function (state, action) {
    return action.payload.reduce(function (s, item) {
        return itemLens(item.uuid).modify(function (i) { return ({
            percent: 100,
            loadedSize: i ? i.loadedSize : 0,
            status: 'FAILED',
            message: item ? item.message : ''
        }); })(s);
    }, state);
};
var uploadedFiles = function (state, action, suffix) {
    if (state === void 0) { state = exports.initialState; }
    var fn = methods[suffix];
    if (fn) {
        return fn(state, action);
    }
    return state;
};
exports.uploadedFiles = uploadedFiles;
